import React, { CSSProperties, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useStoreDispatch, useStoreSelector } from "../../../../store/Hooks";
import { navSliceActions } from "../../../../store/slices/NavSlice";
import { IconButton } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import Interaction from "../../../../models/interactions/Interaction";
import DragIndicatorOutlinedIcon from "@mui/icons-material/DragIndicatorOutlined";
import useConditions from "../../../../hooks/useConditions";
import "./styles/MatrixControls.css";
import InteractionNode from "../../../../models/interactions/InteractionNode";
import InteractionDeleteButton from "../../../interactions/ui/InteractionDeleteButton";
import Tooltip from "@mui/material/Tooltip";

interface MatrixInteractionControlsProps {
  condition_id: number | null;
  interaction: Interaction;
  interaction_node: InteractionNode;
  handleDeleteInteraction: any;
}

const MatrixInteractionControls = (props: MatrixInteractionControlsProps) => {
  const rightDrawerOpen = useStoreSelector(
    (state) => state.nav.rightDrawerOpen,
  );
  const { openConditionsBuilder } = useConditions();

  const dispatch = useStoreDispatch();

  function handleOpenEdit() {
    dispatch(
      navSliceActions.openRightDrawer({
        content: props.interaction,
        type: "interactions",
      }),
    );
  }

  function handleOpenConditions() {
    openConditionsBuilder(
      InteractionNode,
      props.interaction_node.id,
      props.interaction_node.condition_id,
      true,
      "Interaction " + props.interaction.title,
    );
  }

  return (
    <Box
      data-testid={"matrixInteractionControls" + props.interaction.id}
      sx={{ flexGrow: 1, height: "50px" }}
      style={{
        verticalAlign: "middle",
        padding: "0px",
        margin: "0px",
        width: "500px",
      }}
    >
      <Grid container spacing={1} style={{ textAlign: "left" }}>
        <Grid
          item
          xs={12}
          style={{
            fontSize: "12pt",
            marginTop: "20px",
            marginLeft: "20px",
            position: "relative",
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
              width: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginLeft: "15px",
            }}
          >
            {props.interaction.title}
          </div>
          <div
            className={"elementToFadeInAndOut"}
            style={{
              display: "inline-block",
              padding: "0px",
              margin: "0px",
              position: "absolute",
              right: 0,
              top: -10,
            }}
          >
            <Tooltip title = "Edit Interaction">
              <IconButton
                disabled={rightDrawerOpen}
                data-testid={"matrixInteractionEditButton"}
                onClick={handleOpenEdit}
              >
                <ModeEditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title = "Edit Condition">
              <IconButton
                disabled={rightDrawerOpen}
                onClick={handleOpenConditions}
              >
                <CodeIcon />
              </IconButton>
            </Tooltip>
            <InteractionDeleteButton
              interaction={props.interaction}
              handler={props.handleDeleteInteraction}
            />
          </div>
        </Grid>
        <DragIndicatorOutlinedIcon
          sx={{
            marginTop: "-35px",
            color: "gray",
            float: "left",
            fontSize: "2.5em",
            display: "inline-block",
          }}
        />
      </Grid>
    </Box>
  );
};

export default MatrixInteractionControls;
